<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 bg-smoke-light flex">
		<div class="relative bg-grey-lightest w-full max-w-lg m-auto flex-col flex rounded m-8 overflow-scrollable max-h-screen-90 ">
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-2xl font-light inline">Lägg till Bakgrundskarta</p>
				</div>
				<div class="flex-1">
					<button @click="dismissModal()" class="flex items-center justify-center w-24 float-right py-2 pr-2 text-sm text-center text-white block bg-grey hover:bg-grey-dark rounded shadow-light font-bold">
						Stäng
					</button>
				</div>
			</div>

			<div class="pb-8 mt-8 overflow-scroll max-h-screen-80">
				<vue-dropzone  class="mx-8 mb-4" ref="vueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-files-added="validateFiles" @vdropzone-success-multiple="multipleFilesUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="w-3/5 m-auto my-6">
					<p class="text-left mb-2">Koordinatsystem</p>
					<div class="flex">
						<div class="w-2/3">
							<div class="relative">
								<select v-model="epsg" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
									<option value="3021">RT90</option>
									<option value="3006">SWEREF99</option>
									<option value="4326">WGS84</option>
								</select>
								<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
									<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
								</div>
							</div>
						</div>
						
						<button :disabled="!filesUploaded" @click="postFiles()" :class="[ !filesUploaded ? 'disabled' : '', 'bg-green-light hover:bg-green text-grey-darkest font-bold h-content pt-2 pb-3 mx-2 rounded w-1/3']">
							Ladda upp filerna
						</button>
					</div>
					
				</div>

				<p class="text-2xl font-thin" v-text="image_ids.length ? 'Sparade bakgrundskartor' : 'Inga bakgrundskartor tillagda för valt område'" ></p>
				<div class="mx-4 p-4 mt-2 flex flex-wrap content-start max-h-screen-40 overflow-scroll">
					<div class="w-1/3 mb-4" v-for="id in image_ids" :key="id">
						<div class="w-5/6 inline-flex img-dimensions bg-white rounded mb-2 px-2 border border-grey-light">
							<img class="img-max-dimensions rounded self-center mx-auto" :src="getImageUrl(id)">
						</div>
						<button class="bg-grey-light hover:bg-grey text-grey-darkest font-bold py-1 px-6 mx-2 rounded" @click="deleteImage(id)">
							<svg class="w-5 fill-current text-red" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z"/></svg>
						</button>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapGetters } from 'vuex'

export default {

	components: {
		vueDropzone: vue2Dropzone
	},

	data() {
		return {
			show: false,

			filesUploaded: false,
			epsg: "3021",
			image_ids: [],
		}
	},

	computed: {

		...mapGetters({
			customer:		'customer/customer',
			token:			'auth/access_token',
		}),

		dropzoneOptions() {
			return {
				url: this.axios.defaults.baseURL + '/print/backgroundimage',
                headers: { 
					"Authorization": this.token
				},
				autoProcessQueue: false,
				uploadMultiple: true,
				acceptedFiles: ".tif,.jgw,.jpg",
				thumbnailMethod: 'contain',
				parallelUploads: 10,
				createImageThumbnails: false,
                dictDefaultMessage: "Släpp filerna här eller klicka!"
			}
		}
	},

	mounted() {
		bus.$on('open-add-background-map-modal', this.openModal)
		bus.$on('close-add-background-map-modal', this.dismissModal)

		this.retrieveImages()
	},

    beforeDestroy() {
        bus.$off('open-add-background-map-modal')
        bus.$off('close-add-background-map-modal')
    },

	methods: {
		openModal() {
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')

		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},

		/**
		 * Validates the file before upload.
		 * If there is a .jpg or .jpw file, the opposite
		 * must also exist with the same filename
		 */
		validateFiles(filesObject) {
			let files = [...filesObject]
			let validationPassed = true

			files.forEach(file => {
				let fileName = file.name.split('.')[0]
				let fileType = file.name.split('.')[1]
				
				if(fileType == 'jpg' || fileType ==  'jgw') {
					validationPassed = files.some(searchFile => {
						return searchFile.name == fileName + (fileType == 'jpg' ? '.jgw' : '.jpg')
					})
				}
			})

			if(validationPassed) {
				this.filesUploaded = true
			} else {
				this.$refs.vueDropzone.removeAllFiles(true)
				bus.$emit('show-notification', 'Fel på uppladdade filer', 'Det måste finnas ett .jpg och .jgw filpar. De måste heta samma sak och ha de olika filändelserna', 7000)
			}
		},

		postFiles() {
			if(this.filesUploaded) {
				this.$refs.vueDropzone.setOption("params", {
					epsg: this.epsg
				})
				this.$refs.vueDropzone.processQueue()
				this.filesUploaded = false
			} else {
				bus.$emit('show-notification', 'Kan inte ladda upp filer', 'Du måste välja filer först')
			}
		},
		
		/**
		 * Remove the uploaded images from the dropzone 
		 * and add them to the image_ids array
		 */
		multipleFilesUploaded(images, response) {
			images.forEach(image => {
				this.$refs.vueDropzone.removeFile(image)
			})

			response.forEach(img_id => {
				this.image_ids.unshift(img_id)
			})
		},

		uploadError(file, message, xhr) {
			console.log(message)
		},

		retrieveImages() {
			axios.get('/print/backgroundimage')
			.then(response => {
				this.image_ids = response.data
			})
		},

		getImageUrl(id) {
			return this.axios.defaults.baseURL + '/print/backgroundimage/' + id
		},

		deleteImage(id) {
			if(confirm("Vill ta bort bilden från dina uppladdade bilder?")) {
				axios.delete('/print/backgroundimage/' + id)
				.then(response => {
					this.image_ids.splice(this.image_ids.findIndex(img_id => img_id == id), 1)
				})
			}
		},
	}
}
</script>